import {Injectable} from '@angular/core';
import {
    AbstractFindOneByIdService
} from "../../../../../../core/service/v2/service/findone/abstractFindOneById.service";
import {PaymentRequestReminderModel} from "../entity/paymentRequestReminder.model";
import {PaymentRequestReminderRepository} from "../../service/ngrx/paymentRequestReminder.repository";
import {PaymentRequestReminderDataServiceAdapter} from "../../service/ngrx/paymentRequestReminderDataService.adapter";

@Injectable()
export class PaymentRequestReminderFindOneByIdService extends AbstractFindOneByIdService<PaymentRequestReminderModel, PaymentRequestReminderModel> {

    constructor(repository: PaymentRequestReminderRepository, dataServiceAdapter: PaymentRequestReminderDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
